import { render, staticRenderFns } from "./ListResourceTable.vue?vue&type=template&id=742b619b&"
import script from "./ListResourceTable.vue?vue&type=script&lang=js&"
export * from "./ListResourceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports